import MaterialTable from "@material-table/core";
import { useEffect, useState } from "react";
import { log } from "../../Helper";
import { toast } from "react-toastify";
import { chooseWinner } from "../api";
import { GenericButton } from "../../load-build/utility/tooltip";
import LoaderComponent from "../../LoaderComponent/LoaderComponent";
import { InfoIconCustomTooltip } from "./../utility/tooltip";
import { useUserInfo } from "../../common/user-context";
import { currencyPayload } from "./../utility/constants";
import { sortByPriceWithCurrency } from "../../utils/utils";

function SubmittedQuoteDetailsPanel(props) {
  const { userData } = useUserInfo();
  const authorities = userData.authorities;
  const [isLoading, setIsLoading] = useState(false);
  const { rowData, getTableData } = props;
  const [tableData, setTableData] = useState([]);
  const [approveButton, setApproveButton] = useState(false);

  useEffect(() => {
    if (authorities && authorities.includes("ROLE_FULL_APPLICATION_ACCESS")) {
      setApproveButton(true);
    } else if (
      authorities &&
      authorities.includes("ROLE_READ_APPLICATION_ACCESS")
    ) {
      setApproveButton(false);
    }
  }, [userData]);

  useEffect(() => {
    let historicPriceText = "";
    if (
      rowData["quotesHistoricPrices"] != null &&
      rowData["quotesHistoricPrices"].length > 0
    ) {
      historicPriceText = rowData["quotesHistoricPrices"][0].historicPrices;
    }
    let quoteList = [];
    let submittedList = rowData["forwarderSubmittedList"];
    for (let i = 0; i < submittedList?.length || 0; i++) {
      let quote = {
        providerName: "",
        price: "",
        pickupDays: "",
        providerId: "",
        submittedId: "",
        quoteId: "",
        transitDays: "",
        freeText: "",
        quotesHistoricPrices: "",
        shipToZip: "",
        zipCostId: "",
      };
      quote.providerName = submittedList[i].providerName;
      quote.performanceScore = submittedList[i].performanceScore;
      quote.ordersCount = submittedList[i].ordersCount;
      quote.price =
        parseFloat(submittedList[i].price) +
        currencyPayload[submittedList[i].currency];
      quote.pickupDays = submittedList[i].pickupDays;
      quote.transitDays = submittedList[i].transitDays;
      quote.providerId = submittedList[i].providerId;
      quote.submittedId = submittedList[i].submittedId;
      quote.quoteId = submittedList[i].quoteId;
      quote.isActive = submittedList[i].isActive;
      quote.orderPathId = rowData.orderPathId;
      quote.shipToZip = rowData.shipToZip;
      quote.freeText = submittedList[i].freeText;
      quote.zipCostId = submittedList[i].zipCostId;
      quote.quotesHistoricPrices = historicPriceText;

      quoteList.push(quote);
    }

    log("Quote-- ", quoteList);
    const sortedQuoteList = () =>
      quoteList.sort(function (a, b) {
        return sortByPriceWithCurrency(a.price, b.price);
      });

    setTableData(sortedQuoteList);
  }, [rowData]);

  const columns = [
    {
      title: "Forwarder",
      field: "providerName",
      sorting: true,
      hidden: false,
      headerStyle: {
        fontSize: "12px",
      },
    },
    {
      title: "Performance Score (%) (last 3 Months)",
      field: "performanceScore",
      sorting: true,
      hidden: false,
      maxWidth: "100px",
      headerStyle: {
        fontSize: "12px",
      },
    },
    {
      title: "Count of Orders (last 3 Months)",
      field: "ordersCount",
      sorting: true,
      hidden: false,
      maxWidth: "100px",
      headerStyle: {
        fontSize: "12px",
      },
    },
    {
      title: "Price",
      field: "price",
      sorting: true,
      hidden: false,
      maxWidth: "60px",
      headerStyle: {
        fontSize: "12px",
      },
      customSort: (a, b) => {
        return sortByPriceWithCurrency(a.price, b.price);
      },
      padding: "3px",
    },
    {
      title: "",
      field: "quotesHistoricPrices",
      sorting: false,
      hidden: false,
      // width: "9%",
      headerStyle: {
        fontSize: "12px",
        maxWidth: "1px",
      },
      cellStyle: {
        maxWidth: "1px",
      },
      width: "1px",
      render: (rowData) => {
        return InfoIconCustomTooltip(rowData.quotesHistoricPrices);
      },
    },
    {
      title: "Pickup Days",
      field: "pickupDays",
      sorting: true,
      hidden: false,
      maxWidth: "60px",
      headerStyle: {
        fontSize: "12px",
      },
    },
    {
      title: "Transit Days",
      field: "transitDays",
      sorting: true,
      hidden: false,
      maxWidth: "60px",
      headerStyle: {
        fontSize: "12px",
      },
    },
    {
      title: "Free Text",
      field: "freeText",
      sorting: true,
      hidden: false,
      headerStyle: {
        fontSize: "12px",
      },
      minWidth: "150px",
    },
    {
      title: "ProviderId",
      field: "providerId",
      sorting: true,
      hidden: true,
      headerStyle: {
        fontSize: "12px",
      },
    },
    {
      title: "SubmittedId",
      field: "submittedId",
      sorting: true,
      hidden: true,
      headerStyle: {
        fontSize: "12px",
      },
    },
    {
      title: "QuoteId",
      field: "quoteId",
      sorting: true,
      hidden: true,
      headerStyle: {
        fontSize: "12px",
      },
    },
    {
      title: "Zip",
      field: "shipToZip",
      sorting: true,
      hidden: true,
      headerStyle: {
        fontSize: "12px",
      },
    },
    {
      title: "Zip Cost Id",
      field: "zipCostId",
      sorting: true,
      hidden: true,
      headerStyle: {
        fontSize: "12px",
      },
    },
  ];

  return (
    <>
      {isLoading && <LoaderComponent />}
      <div className="flex flex-col p-2 mr-40 ml-40">
        <MaterialTable
          columns={columns}
          localization={{
            body: {
              emptyDataSourceMessage: (
                <h7 className="text-center">No records to display</h7>
              ),
            },
            pagination: {
              labelRowsPerPage: "Orders Per Page",
              labelRowsSelect: "Orders",
            },
          }}
          options={{
            rowStyle: {
              fontSize: 10,
            },
            selection: false,
            toolbar: false,
            search: false,
            showTitle: false,
            grouping: false,
            paging: false,
            filtering: false,
            padding: 0,
            draggable: false,
            actionsColumnIndex: -1,
            headerStyle: {
              backgroundColor: "#99bd93",
              fontWeight: "400",
              color: "white",
              position: "sticky",
              top: 0,
              zIndex: 10,
              height: "60px",
            },
            tableContainerStyle: {
              overflow: "auto",
            },
            filterCellStyle: {
              flex: 1,
            },
            actionsCellStyle: {
              textAlign: "center",
            },
          }}
          title={"Quote Results"}
          data={tableData}
          actions={
            approveButton
              ? [
                  (rowData) => ({
                    icon: () => <GenericButton />,
                    onClick: (event, rowData) => {
                      setIsLoading(true);
                      chooseWinner(rowData).then((response) => {
                        if (response.httpResponse === 200) {
                          setIsLoading(false);
                          toast.success(response.message);
                          getTableData();
                        } else {
                          setIsLoading(false);
                          toast.error(response.message);
                          getTableData();
                        }
                      });
                    },
                  }),
                ]
              : []
          }
        />
      </div>
    </>
  );
}
export default SubmittedQuoteDetailsPanel;
